import { graphql } from "../../codegen/gql";

const languages = graphql(`
  query languages(
    $filterExpression: FilterExpression
    $page: Int
    $pageSize: Int
    $sortField: String
    $sortDirection: SortDirection
  ) {
    languages(
      filterExpression: $filterExpression
      page: $page
      pageSize: $pageSize
      sortField: $sortField
      sortDirection: $sortDirection
    ) {
      totalPages
      totalElements
      first
      last
      number
      size
      numberOfElements
      content {
        id
        name
        flagCode
        es
        it
        fr
        de
        pt
      }
    }
  }
`);

export const LanguageGQL = {
  query: { languages },
  mutation: {},
};
